export default __webpack_public_path__ + "static/media/whitegear.77c0d4ba.svg";